import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { FileTextIcon, ArrowLeftIcon } from 'lucide-react';
import { CancellationAccordion } from '../components/policies/CancellationAccordion';
export function Cancellation() {
  return <>
      <Helmet data-id="element-1358">
        <title data-id="element-1359">Cancellation Policy | Bright Pixxel Studio</title>
        <meta name="description" content="Our refund windows, notice periods and how we handle change requests — clear, fair terms so you always know where you stand. Read the details here." data-id="element-1360" />
        <link rel="canonical" href="https://bright-pixxel.com/cancellation" data-id="element-1361" />
        {/* Open Graph Meta Tags */}
        <meta property="og:locale" content="en_GB" data-id="element-1362" />
        <meta property="og:type" content="website" data-id="element-1363" />
        <meta property="og:title" content="Cancellation Policy | Bright Pixxel Studio" data-id="element-1364" />
        <meta property="og:description" content="Our refund windows, notice periods and how we handle change requests — clear, fair terms so you always know where you stand. Read the details here." data-id="element-1365" />
        <meta property="og:url" content="https://bright-pixxel.com/cancellation" data-id="element-1366" />
        <meta property="og:site_name" content="Bright Pixxel Studio" data-id="element-1367" />
        <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/qh74mEBb962nRk6qjvv9uT/Geometric_Logo_of_Bright_Pixxel_Studio.png" data-id="element-1368" />
        <meta property="og:image:width" content="1200" data-id="element-1369" />
        <meta property="og:image:height" content="630" data-id="element-1370" />
        <meta property="og:image:type" content="image/png" data-id="element-1371" />
        <meta property="og:image:alt" content="Bright Pixxel Studio - Cancellation Policy" data-id="element-1372" />
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-1373" />
        <meta name="twitter:title" content="Cancellation Policy | Bright Pixxel Studio" data-id="element-1374" />
        <meta name="twitter:description" content="Our refund windows, notice periods and how we handle change requests — clear, fair terms so you always know where you stand. Read the details here." data-id="element-1375" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/qh74mEBb962nRk6qjvv9uT/Geometric_Logo_of_Bright_Pixxel_Studio.png" data-id="element-1376" />
        <meta name="twitter:image:alt" content="Bright Pixxel Studio - Cancellation Policy" data-id="element-1377" />
      </Helmet>
      {/* Hero Section */}
      <section className="pt-16 md:pt-24 pb-12 bg-[#F9FAFB] dark:bg-[#121212]" data-id="element-1378">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1379">
          <div className="max-w-4xl mx-auto" data-id="element-1380">
            <Link to="/policies" className="inline-flex items-center text-[#0C1B26] hover:underline mb-6" data-id="element-1381">
              <ArrowLeftIcon size={16} className="mr-1" data-id="element-1382" />
              Back to Policies
            </Link>
            <div className="flex items-center mb-6" data-id="element-1383">
              <div className="w-12 h-12 rounded-full bg-[#0C1B26]/10 dark:bg-[#0C1B26]/20 flex items-center justify-center mr-4" data-id="element-1384">
                <FileTextIcon size={24} className="text-[#0C1B26]" data-id="element-1385" />
              </div>
              <motion.h1 initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              duration: 0.5
            }} className="text-3xl md:text-4xl font-bold" data-id="element-1386">
                Cancellation Policy
              </motion.h1>
            </div>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="text-lg text-gray-600 dark:text-gray-300 mb-4" data-id="element-1387">
              Last Updated: May 1, 2023
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="text-lg text-gray-600 dark:text-gray-300" data-id="element-1388">
              This Cancellation Policy outlines the terms and conditions
              regarding cancellations, refunds, and changes to projects and
              services provided by Bright Pixxel Studio ("we", "us", "our"). By
              engaging our services, you agree to the terms set forth in this
              policy.
            </motion.p>
          </div>
        </div>
      </section>
      {/* Policy Content */}
      <section className="py-12 bg-white dark:bg-[#1E1E1E]" data-id="element-1389">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1390">
          <div className="max-w-4xl mx-auto" data-id="element-1391">
            <CancellationAccordion data-id="element-1392" />
          </div>
        </div>
      </section>
    </>;
}